import React from "react";
import { View, StyleSheet } from "react-native";
import { WarningCircle } from "@phosphor-icons/react";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";

interface CompanionErrorModalProps {
  visible: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onRetry?: () => void;
  retryButtonText?: string;
}

function CompanionErrorModal({
  visible,
  title,
  message,
  onClose,
  onRetry,
  retryButtonText = "Retry",
}: CompanionErrorModalProps) {
  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      exitFill="#BBB"
      style={styles.modalView}
      bodyStyle={styles.body}>
      <View style={styles.container}>
        <View style={styles.iconRow}>
          <WarningCircle size={40} weight="fill" color="#DC2626" aria-hidden />
        </View>
        <CustomSpacing type="vertical" size="l" />
        <CustomText text={title} size="xxl" weight="ultraBold" style={styles.title} useTranslationText={false} />
        <CustomSpacing type="vertical" size="l" />
        <CustomText text={message} size="l" style={styles.message} useTranslationText={false} />
        <CustomSpacing type="vertical" size="l" />
        <CustomSpacing type="vertical" size="xxl" />
        <View style={styles.buttonBox}>
          {onRetry && (
            <CustomButton
              text={retryButtonText}
              styleType="primary"
              onPress={onRetry}
              style={styles.actionButton}
              aria-label={retryButtonText}
            />
          )}
          <CustomButton
            text="Close"
            styleType={onRetry ? "secondary" : "primary"}
            onPress={onClose}
            style={styles.actionButton}
            aria-label="Close error modal"
          />
        </View>
      </View>
    </CustomModal>
  );
}

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 20,
    padding: 40,
    maxWidth: 688,
    width: "auto",
    backgroundColor: "white",
  },
  body: {
    marginTop: 0,
  },
  container: {
    alignItems: "center",
  },
  iconRow: {
    alignItems: "center",
  },
  title: {
    color: "#101828",
    textAlign: "center",
  },
  message: {
    color: "#344054",
    textAlign: "center",
  },
  buttonBox: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 16,
  },
  actionButton: {
    maxWidth: 150,
  },
});

export default CompanionErrorModal;
